import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useMemo } from 'react';
import { ThemeProvider as ThemeUIProvider } from '@theme-ui/core';
import { theme } from './theme';
function ThemeProvider(_ref) {
  var children = _ref.children,
    whitelabelColors = _ref.whitelabelColors;
  var themeInContext = useMemo(function () {
    return _objectSpread(_objectSpread({}, theme), {}, {
      colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
        whitelabel: _objectSpread(_objectSpread({}, theme.colors.whitelabel), whitelabelColors)
      })
    });
  }, [whitelabelColors]);
  return /*#__PURE__*/React.createElement(ThemeUIProvider, {
    theme: themeInContext
  }, children);
}
export { ThemeProvider };